/* L'Orchidea - barra annunci (sections/orc-annunci.liquid): rotazione delle scritte, frecce, pausa,
   chiusura ricordata finche' non cambia il testo, anteprima della scritta selezionata nell'editor. */
if (!customElements.get('orc-annunci')) {
  customElements.define('orc-annunci', class extends HTMLElement {
    connectedCallback() {
      this.chiave = `orc-annunci-chiuso:${this.dataset.chiave || ''}`;
      try {
        if (!window.Shopify?.designMode && localStorage.getItem(this.chiave) === '1') { this.hidden = true; return; }
      } catch (e) { /* storage non disponibile */ }
      this.querySelector('[data-ann-chiudi]')?.addEventListener('click', () => {
        this.hidden = true;
        clearTimeout(this.timer);
        try { localStorage.setItem(this.chiave, '1'); } catch (e) { /* storage non disponibile */ }
      });
      if (this.hasAttribute('data-continuo')) return;

      this.voci = [...this.querySelectorAll('[data-ann-voce]')];
      this.indice = 0;
      this.durata = parseInt(this.dataset.durata, 10) || 5000;
      this.vel = parseFloat(getComputedStyle(this).getPropertyValue('--ann-vel')) || 600;
      if (this.classList.contains('orc-ann--testo-lettere')) this.dividiLettere();
      if (this.voci.length < 2) return;

      this.querySelector('[data-ann-prima]')?.addEventListener('click', () => this.vai(this.indice - 1, true));
      this.querySelector('[data-ann-dopo]')?.addEventListener('click', () => this.vai(this.indice + 1, true));
      if (this.hasAttribute('data-pausa')) {
        this.addEventListener('mouseenter', () => this.ferma());
        this.addEventListener('mouseleave', () => this.riparti());
        this.addEventListener('focusin', () => this.ferma());
        this.addEventListener('focusout', () => this.riparti());
      }
      document.addEventListener('visibilitychange', () => (document.hidden ? this.ferma() : this.riparti()));
      // editor del tema: selezionando una scritta la barra si ferma su quella
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.voci.findIndex((v) => v.dataset.block === e.detail.blockId);
        if (i > -1) { this.bloccata = true; this.vai(i); this.ferma(); }
      });
      document.addEventListener('shopify:block:deselect', () => { this.bloccata = false; this.riparti(); });
      this.riparti();
    }

    disconnectedCallback() { clearTimeout(this.timer); }

    // divide in lettere solo i nodi di testo: grassetto, corsivo e icone restano intatti
    dividiLettere() {
      this.querySelectorAll('.orc-ann__testo').forEach((t) => {
        t.setAttribute('aria-label', t.textContent.trim());
        const nodi = [];
        const giro = document.createTreeWalker(t, NodeFilter.SHOW_TEXT);
        while (giro.nextNode()) nodi.push(giro.currentNode);
        let i = 0;
        nodi.forEach((nodo) => {
          const pezzi = document.createDocumentFragment();
          [...nodo.textContent].forEach((c) => {
            const s = document.createElement('span');
            s.className = 'orc-ann__lettera';
            s.setAttribute('aria-hidden', 'true');
            s.style.setProperty('--i', i++);
            s.textContent = c;
            pezzi.append(s);
          });
          nodo.replaceWith(pezzi);
        });
      });
    }

    ferma() { clearTimeout(this.timer); }

    riparti() {
      clearTimeout(this.timer);
      if (this.bloccata || document.hidden) return;
      this.timer = setTimeout(() => this.vai(this.indice + 1), this.durata);
    }

    vai(n, manuale) {
      const tot = this.voci.length;
      const prossimo = (n + tot) % tot;
      if (prossimo === this.indice) return;
      const prima = this.voci[this.indice];
      const dopo = this.voci[prossimo];
      // la nuova scritta parte dalla posizione di entrata, senza animazione
      dopo.classList.add('is-ferma');
      dopo.classList.remove('is-uscita');
      void dopo.offsetWidth;
      dopo.classList.remove('is-ferma');
      prima.classList.remove('is-attiva');
      prima.classList.add('is-uscita');
      dopo.classList.add('is-attiva');
      this.accessibile(prima, false);
      this.accessibile(dopo, true);
      setTimeout(() => {
        prima.classList.add('is-ferma');
        prima.classList.remove('is-uscita');
        void prima.offsetWidth;
        prima.classList.remove('is-ferma');
      }, this.vel + 50);
      this.indice = prossimo;
      if (manuale || !(this.hasAttribute('data-pausa') && this.matches(':hover'))) this.riparti();
    }

    accessibile(voce, visibile) {
      voce.setAttribute('aria-hidden', visibile ? 'false' : 'true');
      voce.querySelector('a')?.setAttribute('tabindex', visibile ? '0' : '-1');
    }
  });
}
